/**
 * The text of an agenda file the clerk already has: a PDF is read here in
 * the browser; a Word file is read by the server. Either way the text lands
 * in the agenda box for the clerk to check before saving.
 */
import { api } from "./api";

async function pdfText(file: File): Promise<string> {
  const pdfjs = await import("pdfjs-dist");
  pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
  const doc = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
  const pages: string[] = [];
  for (let n = 1; n <= doc.numPages; n++) {
    const content = await (await doc.getPage(n)).getTextContent();
    let page = "";
    for (const item of content.items) {
      if (!("str" in item)) continue;
      page += item.str + (item.hasEOL ? "\n" : "");
    }
    pages.push(page);
  }
  return pages.join("\n").replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}

async function base64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let s = "";
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(s);
}

export async function agendaFileText(meetingId: string, file: File): Promise<string> {
  if (/\.pdf$/i.test(file.name)) return pdfText(file);
  if (/\.docx$/i.test(file.name)) {
    const r = await api.post<{ text: string }>(`/api/meetings/${meetingId}/agenda/read`, { docxBase64: await base64(file) });
    return r.text;
  }
  throw new Error("Choose the agenda as a PDF or a Word .docx file.");
}
